module.exports = __webpack_public_path__ + "media/images/flags/KZ-8751707dae2543871f389973bb7dde0d.svg";